
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { useLanguage } from "@/context/LanguageContext";

export const BasicFields = ({ form }: { form: UseFormReturn<any> }) => {
  const { language, t } = useLanguage();
  
  const getLandlordLabel = () => {
    return language === 'en' ? 'Landlord or Community Name' : '房東或社區名稱';
  };
  
  return (
    <FormField
      control={form.control}
      name="community_name"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {getLandlordLabel()}
          </FormLabel>
          <FormControl>
            <Input {...field} value={field.value || ''} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
